import React from 'react';
import Card from './ui/Card';
import Button from './ui/Button';
import SectionWrapper from './ui/SectionWrapper';
import { getTalentPoolPath } from '../../utils/talentPoolNavigation';

const cards = [
  {
    heading: 'For Creators',
    title: 'Learn. Build.\nGet Discovered.',
    steps: [
      {
        n: '01',
        text: 'Skill, Upskill or Reskill',
        desc: 'Industry-aligned courses with structured learning paths.',
      },
      {
        n: '02',
        text: 'Get Certified',
        desc: 'Earn platform-backed credentials that signal credibility.',
      },
      {
        n: '03',
        text: 'Build Your Profile',
        desc: 'Portfolio, reels, pitch decks — all in one place.',
      },
      {
        n: '04',
        text: 'Pitch & Get Hired',
        desc: 'Submit ideas to production houses and get shortlisted.',
      },
    ],
    cta: 'Start for free →',
    to: '/profile',
  },
  {
    heading: 'For Recruiters',
    title: 'Search. Verify.\nHire Fast.',
    steps: [
      {
        n: '01',
        text: 'Post a Brief',
        desc: 'Describe role, project type and required skill sets.',
      },
      {
        n: '02',
        text: 'Filter Certified Talent',
        desc: 'Narrow by discipline, location and certification level.',
      },
      {
        n: '03',
        text: 'Review & Shortlist',
        desc: 'Compare standardized profiles, reels and pitch decks.',
      },
      {
        n: '04',
        text: 'Hire with Confidence',
        desc: 'Connect, negotiate and onboard from one platform.',
      },
    ],
    cta: 'Browse talent →',
    to: '/profiles',
  },
  {
    heading: 'For Investors',
    title: 'Discover. Fund.\nTrack.',
    steps: [
      {
        n: '01',
        text: 'Browse Screened Pitches',
        desc: 'AI-verified story pitches filtered by genre and viability.',
      },
      {
        n: '02',
        text: 'Evaluate with AI Insights',
        desc: 'ROI signals, audience fit and story viability checks.',
      },
      {
        n: '03',
        text: 'Connect with Creators',
        desc: 'Chat directly with verified project leads and producers.',
      },
      {
        n: '04',
        text: 'Fund & Track Progress',
        desc: 'Follow milestones and updates through the platform.',
      },
    ],
    cta: 'Explore pitches →',
    to: '/producer-pitches',
  },
];

export default function PathCardsSection({ onNavigate, user }) {
  const creatorsPath = getTalentPoolPath(user?.userType);

  return (
    <SectionWrapper>
      <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900">
          Your path, <span className="italic text-[#C8A75B] font-medium">defined.</span>
        </h2>
        <p className="text-sm text-gray-500 max-w-sm">
          Three distinct journeys. Every step built around one outcome: a real opportunity.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        {cards.map((card) => (
          <Card key={card.heading} className="rounded-xl p-6">
            <p className="text-xs font-semibold tracking-wider uppercase text-gray-400">
              {card.heading}
            </p>
            <h3 className="mt-2 whitespace-pre-line text-4xl font-bold leading-tight text-gray-900">
              {card.title}
            </h3>

            <div className="mt-5 space-y-4">
              {card.steps.map((s) => (
                <div key={`${card.heading}-${s.n}`} className="border-t border-gray-100 pt-3">
                  <div className="flex items-start gap-3">
                    <span className="mt-0.5 rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-bold text-gray-500">
                      {s.n}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-gray-800">{s.text}</p>
                      <p className="mt-1 text-xs text-gray-500 leading-relaxed">{s.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <Button
              type="button"
              variant="text"
              onClick={() => onNavigate(card.heading === 'For Creators' ? creatorsPath : card.to)}
              className="mt-6"
            >
              {card.cta}
            </Button>
          </Card>
        ))}
      </div>
    </SectionWrapper>
  );
}

